import mixpanel from 'mixpanel-browser';

mixpanel.init('33fdce2b8500301526e8a5ab54d39395');

const env_check = process.env.REACT_APP_MIXPANEL === 'production';

const actions = {
  identify: (id?: string) => {
    if (env_check) mixpanel.identify(id);
  },
  alias: (id: string) => {
    if (env_check) mixpanel.alias(id);
  },
  track: (name: string, props?: any) => {
    if (env_check) mixpanel.track(name, props);
  },
  people: {
    set: (props: any) => {
      if (env_check) mixpanel.people.set(props);
    },
  },
};

export const Mixpanel = actions;
